/*eslint-disable */
import React from 'react'
import { Button, Dropdown, Modal} from 'semantic-ui-react'
import { withFormik, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi } from "semantic-ui-react";
import { MyNormalInput } from '../dynamicComponent/myInputs';
import UpdateAxios from '../axiosComponent/update';
import CreatAxios from '../axiosComponent/create';
import { FIELD_IS_REQUIRED } from '../../utils/validationConstant';
import cogoToast from 'cogo-toast';
import MyPSLineItem from '../apiInputs/psLineItem';
import { LABELS, MESSAGES, TITLES } from './vendorPSLineGSTMapping.constants';
import ModeOfTransportDropdown from '../dropdowns/modeOfTransportDropdown';

const VendorPSLineGSTMappingEdit = ({ isSubmitting, handleSubmit, values, vendorId, setFieldValue, touched, errors, mappingModal, CloseModal, editUserMode ,editData}) => {
  
    return (
        <Modal
            onClose={CloseModal}
            open={mappingModal}
            size="large"
            className="p-overflow-initial"
        >
            <Modal.Header style={{ fontSize: "14px" }}>{editData ? TITLES.editProductGST : TITLES.addProductGST}</Modal.Header>
            <Modal.Content scrolling>
                <div className="ui form small">
                    <FormUi.Group inline={errors.billingPartyBranchName ? false : true}>
                    <FormUi.Field width="2">
                            <label className="labelName">{LABELS.product || "Product"}<b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="psLineItemId"
                                component={MyPSLineItem}
                                citynameValue={true}
                                placeholder ={ values.psDescription ? values.psDescription : LABELS.product || "Product"}
                            />
                             {touched.psLineItemId && errors.psLineItemId ? <small className="text-danger">{errors.psLineItemId}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="3" />
                        <FormUi.Field width="2">
                            <label className="labelName">{LABELS.gstPercent || "GST Percent"}{" "}<b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field width="4" error={values.billingPartyBranchName ? false : true}>
                            <Fieldmik name="gstPercent" component={MyNormalInput} placeholder ={LABELS.gstPercent || "GST Percent"} maxLength={10}/>
                        {touched.gstPercent && errors.gstPercent ? <small className="text-danger">{errors.gstPercent}</small> : ''}
                        </FormUi.Field>

                        
                    </FormUi.Group>
                    <FormUi.Group inline>
                        <FormUi.Field width="2">
                            <label className="labelName">{LABELS.transportMode || "Transport Mode"}<b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field  width="4">
                        <Fieldmik name="transportModeId" component={ModeOfTransportDropdown} placeholder ={values.transportMode || LABELS.transportMode || "Transport Mode"} />   
                            {touched.transportModeId && errors.transportModeId ? <small className="text-danger">{errors.transportModeId}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="3" />
                        <FormUi.Field width="2"/>

                        <FormUi.Field  width="4"/>
                    </FormUi.Group>

                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color='green' size="mini" type='button' onClick={CloseModal}>
                    {"cancel"}
                </Button>
                <Button type='submit' disabled={isSubmitting} onClick={handleSubmit} size="mini" color="blue">
                    {"ok"}
                </Button>
            </Modal.Actions>
        </Modal>
    )
}

const FormikUserEdit = withFormik({
    
    enableReinitialize: true,
    mapPropsToValues: (props, gstPercent, psDescription, psLineItemId, transportMode, transportModeId
        ) => {
        return {
            gstPercent: (props.editData != null ? props.editData.gstPercent : gstPercent) || '',
            psDescription: (props.editData != null ? props.editData.psDescription : psDescription) || '',
            psLineItemId: (props.editData != null ? props.editData.psLineItemId : psLineItemId) || '',
            transportMode: (props.editData != null ? props.editData.transportMode : transportMode) || '',
            transportModeId: (props.editData != null ? props.editData.transportModeId : transportModeId) || '',
        }
    },
    validationSchema: yup.object({
        gstPercent: yup.number()
                    .typeError(MESSAGES.onlyWholeNumberAllowed)
                    .required(FIELD_IS_REQUIRED)
                    .max(100)
                    .min(0)
                    .integer(),
        psLineItemId: yup.string().required(FIELD_IS_REQUIRED),
        transportModeId: yup.string().required(FIELD_IS_REQUIRED),
    }),
    async handleSubmit(values, { props }) {
        if (props.editData) {


            await UpdateAxios({
                completeURL: `${process.env.REACT_APP_MASTER_API}/vendorPSLineItemGSTMapping/${props.editData.vendorPSLineItemGSTMappingId}`,
                payload: { ...values, vendorId: props.vendorId },
            }).then((response) => {
                cogoToast.success(MESSAGES.editProductGSTSuccess ||  "Product GST updated successfully", { position: "top-right" })
                setTimeout(() => {
                    window.location.reload()
                  }, 1000);
            })
                .catch((err) => {
                    if (err.data.status === 204) {
                        cogoToast.error(MESSAGES.editProductGSTError || "Unable to update product GST", { position: "top-right" })
                    }
                });
        } else {
            
            await CreatAxios({
                completeURL: `${process.env.REACT_APP_MASTER_API}/vendorPSLineItemGSTMapping`,
                payload: { ...values, vendorId: props.vendorId },
            })
                .then((res) => {
                    console.log("tes");
                    console.log(res);
                    cogoToast.success(MESSAGES.addProductGSTSuccess || "Product GST created successfully", { position: "top-right" })

                    setTimeout(() => {
                        window.location.reload()
                      }, 1000);
                })
                .catch((err) => {
                    console.log({err})
                    if (err) {
                        cogoToast.error( err.response?.data?.message || MESSAGES.addProductGSTError || "Unable to create Product GST", { position: "top-right" })
                    }
                    
                    
                });
        }
    }

})(VendorPSLineGSTMappingEdit)
export default FormikUserEdit
